// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"e90da4e9","37":"84987ba3","55":"116202fa","171":"9226ab8a","239":"e39fb35b","429":"329d66e2","455":"c2013aea","778":"830b5330","977":"4b3215a8"}[chunkId] + ".chunk.js";
};